export default "__VITE_ASSET__BenqkvY9__"